module.exports = __webpack_public_path__ + "static/img/info.8327461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/info.png
// module id = Bld5
// module chunks = 44